// Hai biến thể hiển thị thông tin pháp nhân, đọc từ @/lib/business-info.
// Trường nào là null trong config sẽ tự ẩn — không cần sửa component khi đổi pháp nhân.
import { Building2, Fingerprint, Globe, Mail } from "lucide-react";
import { BUSINESS_INFO } from "@/lib/business-info";

/** Khối có icon, dùng trong footer trang công khai. */
export function BusinessInfoBlock() {
  return (
    <div className="space-y-2.5 text-sm">
      <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-primary">
        <Building2 className="h-3.5 w-3.5" /> {BUSINESS_INFO.blockLabel}
      </p>
      <p className="font-medium text-foreground">{BUSINESS_INFO.name}</p>
      {BUSINESS_INFO.taxCode ? (
        <p className="flex items-center gap-2 text-muted-foreground">
          <Fingerprint className="h-4 w-4 shrink-0 text-primary/70" /> MST:{" "}
          <span className="text-foreground/90">{BUSINESS_INFO.taxCode}</span>
        </p>
      ) : null}
      {BUSINESS_INFO.website ? (
        <a
          href={`https://${BUSINESS_INFO.website}`}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 text-muted-foreground transition hover:text-primary"
        >
          <Globe className="h-4 w-4 shrink-0 text-primary/70" /> {BUSINESS_INFO.website}
        </a>
      ) : null}
      {BUSINESS_INFO.email ? (
        <a
          href={`mailto:${BUSINESS_INFO.email}`}
          className="flex items-center gap-2 text-muted-foreground transition hover:text-primary"
        >
          <Mail className="h-4 w-4 shrink-0 text-primary/70" /> {BUSINESS_INFO.email}
        </a>
      ) : null}
    </div>
  );
}

/** Thẻ chữ thuần, dùng cuối các trang tĩnh (điều khoản, hướng dẫn, hoa hồng). */
export function BusinessInfoCard() {
  return (
    <section className="rounded-2xl border border-gold-soft/40 bg-background/30 p-5 text-sm text-muted-foreground">
      <p className="font-medium text-foreground">{BUSINESS_INFO.name}</p>
      {BUSINESS_INFO.taxCode ? <p className="mt-1">Mã số thuế: {BUSINESS_INFO.taxCode}</p> : null}
      {BUSINESS_INFO.website ? <p>Website: {BUSINESS_INFO.website}</p> : null}
      {BUSINESS_INFO.email ? <p>Email: {BUSINESS_INFO.email}</p> : null}
    </section>
  );
}
